import { AuthenticationContext, adalFetch } from "react-adal";
import jwt from "jsonwebtoken"
import { UserRoles } from "../state/constants/UserRoles";

const environment = process.env.REACT_APP_ENVIRONMENT;

const tenantEnv = process.env.REACT_APP_TENANT;
const clientIdEnv = process.env.REACT_APP_CLIENT_ID;
const redirectUriEnv = process.env.REACT_APP_REDIRECT_URI;
const baseUrl = process.env.REACT_APP_BASE_URL;

let config = {
  tenant: tenantEnv,
  clientId: clientIdEnv,
  redirectUri: redirectUriEnv,
  endpoints: {
    api: baseUrl,
  },
  cacheLocation: "sessionStorage"
};

export const authContext = new AuthenticationContext(config);

export const getToken = () => authContext.getCachedToken(config.clientId);
export const getTokenAsync = (callback) => authContext.acquireToken(config.clientId, callback);
export const getUser = () => authContext.getCachedUser(config.clientId);
export const logout = () => authContext.logOut();
export const login = () => authContext.login();
export const adalApiFetch = (fetch, url, options) => adalFetch(authContext, config.clientId, fetch, url, options);

export const getUserRoles = (callback) => {
  const { COMMERICAL, IT_ADMIN, DISTRIBUTOR } = UserRoles
  getTokenAsync((errorDesc, token, error) => {
    const decodedToken = jwt.decode(token);

    let roles = []

    if (decodedToken && decodedToken.roles) {
      roles = decodedToken.roles.map(role => {
        switch (role) {
          case COMMERICAL:
            return COMMERICAL
          case IT_ADMIN:
            return IT_ADMIN
          case DISTRIBUTOR:
            return DISTRIBUTOR
          default:
            return null
        }
      });
    } else {
      console.log(token)
    }

    callback(roles)
  });
}

export const checkLoggedIn = (callback) => {
  getTokenAsync((errorDesc, token, error) => {
    if (token != null) {
      callback(true)
    } else {
      callback(false)
    }
  })
}